<template>
  <section style="">
    <form method="post" @submit.prevent="onSend" novalidate>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title is-centered">
            {{ title }}
          </p>
        </header>

        <section class="modal-card-body">
          <form-wrapper :validator="$v.form">
            <div class="columns mb-0">
              <div class="column">
                <form-group
                  name="name"
                  :label="$t('attributes.name')"
                  label-position="on-border"
                >
                  <b-input
                    v-model="form.name"
                    name="name"
                    :placeholder="
                      $t('message.please_input') + $t('attributes.name')
                    "
                    expanded
                  >
                  </b-input>
                </form-group>
              </div>
              <div class="column">
                <form-group
                  horizontal
                  name="picture"
                  attribute="attributes.picture"
                  :label="$t('attributes.picture')"
                  grouped
                >
                  <template #label>
                    <b-tooltip
                      type="is-dark"
                      position="is-bottom"
                      label="200*200/限png,jpg檔，100KB內"
                      style="margin-right: -16px; width: 60px;"
                    >
                      {{ $t('attributes.picture') }}
                      <b-icon
                        size="is-small"
                        type="is-danger"
                        icon="help-circle-outline"
                      ></b-icon>
                    </b-tooltip>
                  </template>
                  <b-field class="file">
                    <a class="button is-primary" @click="onSelectPictureImage">
                      <b-icon icon="upload"></b-icon>
                      <span>{{ $t('message.please_select_file') }}</span>
                    </a>
                    <figure v-if="form.picture" class="image">
                      <img
                        :src="GiftImage(form.picture)"
                        :alt="$t('attributes.picture')"
                        style="height: 40px; margin-left: 6px;"
                      />
                    </figure>
                  </b-field>
                </form-group>
              </div>
            </div>

            <div class="columns mb-0">
              <div class="column">
                <form-group
                  name="put_on_shelves"
                  attribute="attributes.shelve_status"
                  :label="$t('attributes.shelve_status')"
                  label-position="on-border"
                >
                  <b-select v-model="form.put_on_shelves" expanded>
                    <option :value="false">
                      {{ $t('attributes.shelve_off') }}
                    </option>
                    <option :value="true">
                      {{ $t('attributes.shelve_on') }}
                    </option>
                  </b-select>
                </form-group>
              </div>
            </div>

            <div class="columns mb-0">
              <div class="column">
                <form-group
                  name="sort"
                  attribute="attributes.sort"
                  :label="$t('attributes.sort')"
                  label-position="on-border"
                >
                  <b-select v-model="form.sort" expanded>
                    <option
                      v-for="option in sortOptions"
                      :key="option"
                      :value="option"
                    >
                      {{ option }}
                    </option>
                  </b-select>
                </form-group>
              </div>
            </div>

            <div class="columns mb-0">
              <div class="column">
                <form-group
                  name="department_no"
                  attribute="attributes.gift_department"
                  :label="$t('attributes.gift_department')"
                  label-position="on-border"
                >
                  <b-select
                    v-model="selectedDepartNo"
                    :loading="loadingDepart"
                    :disabled="isUpdate"
                    :placeholder="
                      $t('message.please_select') +
                        $t('attributes.gift_department')
                    "
                    @input="onSelectDepart"
                    expanded
                  >
                    <option value="">總公司</option>
                    <option
                      v-for="option in departs"
                      :value="option.id"
                      :key="option.id"
                    >
                      {{ option.name }}
                    </option>
                  </b-select>
                </form-group>
              </div>

              <div class="column">
                <form-group
                  name="employee_code"
                  attribute="attributes.gift_employee"
                  :label="$t('attributes.gift_employee')"
                  label-position="on-border"
                >
                  <b-select
                    v-model="selectedEmployeeCode"
                    :loading="loadingEmployee"
                    :disabled="form.department_no == null"
                    :placeholder="
                      $t('message.please_select') +
                        $t('attributes.gift_employee')
                    "
                    @input="onSelectEmployee"
                    expanded
                  >
                    <option value="">不指定</option>
                    <option
                      v-for="option in employees"
                      :value="option.emp_code"
                      :key="option.emp_code"
                    >
                      {{ employeeFullName(option) }}
                    </option>
                  </b-select>
                </form-group>
              </div>
            </div>

            <div class="columns mb-0">
              <div class="column">
                <form-group
                  name="low_quantity"
                  attribute="attributes.gift_quantity"
                  :label="$t('attributes.gift_low_quantity')"
                  label-position="on-border"
                  title="數量低於此數值將發信提醒"
                >
                  <b-input
                    v-model.number="form.low_quantity"
                    type="number"
                    name="low_quantity"
                    min="0"
                    :placeholder="
                      $t('message.please_input') +
                        $t('attributes.gift_low_quantity')
                    "
                    expanded
                  >
                  </b-input>
                </form-group>
              </div>
            </div>

            <div class="columns mb-0">
              <div class="column">
                <form-group
                  name="consumable"
                  attribute="attributes.gift_consumable"
                  :label="$t('attributes.gift_consumable')"
                  label-position="on-border"
                >
                  <b-select
                    v-model="form.consumable"
                    name="consumable"
                    :disabled="isUpdate"
                    expanded
                    @input="onSelectConsumable"
                  >
                    <option :value="false">{{ $t('attributes.no') }}</option>
                    <option :value="true">{{ $t('attributes.yes') }}</option>
                  </b-select>
                </form-group>
              </div>
              <div class="column">
                <form-group
                  name="limit_times"
                  attribute="attributes.gift_limit_times"
                  :label="$t('attributes.gift_limit_times')"
                  label-position="on-border"
                >
                  <b-select
                    v-model="form.limit_times"
                    name="limit_times"
                    expanded
                  >
                    <option :value="0">{{ $t('attributes.yes') }}</option>
                    <option :value="1">{{ $t('attributes.no') }}</option>
                  </b-select>
                </form-group>
              </div>
            </div>

            <div class="columns mb-0">
              <div class="column">
                <form-group
                  name="dividend_point"
                  attribute="attributes.gift_dividend_point"
                  :label="$t('attributes.gift_dividend_point')"
                  label-position="on-border"
                >
                  <b-input
                    v-model.number="form.dividend_point"
                    type="number"
                    name="dividend_point"
                    min="0"
                    :disabled="form.consumable"
                    :placeholder="
                      $t('message.please_input') +
                        $t('attributes.gift_dividend_point')
                    "
                    expanded
                  >
                  </b-input>
                </form-group>
              </div>
              <div class="column"></div>
            </div>
          </form-wrapper>
        </section>

        <footer class="modal-card-foot">
          <b-button
            :loading="sending"
            class="is-fullwidth"
            @click="$parent.close()"
          >
            {{ $t('attributes.close') }}
          </b-button>
          <b-button
            :loading="sending"
            type="is-primary"
            class="is-fullwidth"
            native-type="submit"
          >
            {{ isNew ? $t('attributes.add') : $t('attributes.update') }}
          </b-button>
        </footer>

        <b-loading
          :active.sync="isLoading"
          :is-full-page="false"
          :can-cancel="false"
        ></b-loading>
      </div>
    </form>
  </section>
</template>

<script>
import {
  required,
  maxLength,
  numeric,
  minValue,
  requiredIf
} from 'vuelidate/lib/validators'
import { DEPARTMENTS_API, EMPLOYEES_API } from '@/utils/apis'
import notifyService from '@/services/notifyService'
import { OpenGiftFinder } from '@/utils/ckfinder'

export default {
  name: 'GiftForm',

  props: {
    gift: {
      type: Object,
      required: true
    },
    sending: {
      type: Boolean,
      required: true
    }
  },
  data() {
    const isNew = !this.gift.id
    const title = isNew
      ? this.$t('attributes.add')
      : this.$t('attributes.modify')
    return {
      isNew: isNew,
      isUpdate: !isNew,
      title: title,

      loadingDepart: false,
      selectedDepartNo: '',
      departs: [],

      loadingEmployee: false,
      selectedEmployeeCode: '',
      employees: [],

      loading: false,
      form: this.extractFormValues(this.gift),
      sortOptions: [...Array(999).keys()].map(i => i + 1)
    }
  },
  validations: {
    form: {
      name: { required, maxLength: maxLength(200) },
      quantity: { required, numeric, minValue: minValue(0) },
      stock: { required, numeric, minValue: minValue(0) },
      low_quantity: { required, numeric, minValue: minValue(0) },
      employee_code: {
        requiredIf: requiredIf(function(model) {
          return model.department_no != null
        })
      },
      consumable: { required },
      limit_times: { required, minValue: minValue(0) },
      cost: { required, minValue: minValue(0.0) },
      net_price: { required, minValue: minValue(0) },
      sale_price: { required, minValue: minValue(0) },
      dividend_point: { required, minValue: minValue(0) },
      picture: { maxLength: maxLength(200) },
      put_on_shelves: { required },
      sort: { required }
    }
  },
  computed: {
    isLoading() {
      return this.loading || this.sending
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    async loadData() {
      this.loading = true
      await this.loadDepartment()
      await this.loadEmployee()
      this.loading = false
    },
    extractFormValues(data) {
      this.selectedDepartNo = data.department_no || ''
      this.selectedEmployeeCode = data.employee_code || ''
      return {
        id: data.id,
        name: data.name,
        quantity: data.quantity,
        stock: data.stock,
        low_quantity: data.low_quantity,
        department_no: data.department_no,
        employee_code: data.employee_code,
        consumable: data.consumable,
        limit_times: data.limit_times,
        cost: data.cost,
        net_price: data.net_price,
        sale_price: data.sale_price,
        dividend_point: data.dividend_point,
        picture: data.picture && data.picture.trim(),
        put_on_shelves: data.put_on_shelves,
        sort: data.sort
      }
    },
    async loadDepartment() {
      try {
        this.loadingDepart = true
        const res = await this.axios.get(DEPARTMENTS_API)
        this.departs = res.data.data

        const depart =
          this.departs.find(d => d.id === this.form.department_no) || null
        this.form.department_no = depart && depart.id
        this.selectedDepartNo = this.form.department_no || ''
      } catch (e) {
        this.departs = []
        this.form.department_no = null
        this.selectedDepartNo = ''

        notifyService.fetch_error('depart', e)
      } finally {
        this.loadingDepart = false
      }
    },
    async loadEmployee() {
      if (this.form.department_no == null) {
        this.employees = []
        this.form.employee_code = null
        this.selectedEmployeeCode = ''
        return
      }

      try {
        const api = `${EMPLOYEES_API}/list`
        const params = {
          depart: this.form.department_no,
          status: 1
        }

        this.loadingEmployee = true
        const res = await this.axios.get(api, { params })
        this.employees = res.data.data

        const employee =
          this.employees.find(e => e.emp_code === this.form.employee_code) ||
          null

        this.form.employee_code = employee && employee.emp_code
        this.selectedEmployeeCode = this.form.employee_code || ''
      } catch (e) {
        this.employees = []
        this.form.employee_code = null
        this.selectedEmployeeCode = ''

        notifyService.fetch_error('employee', e)
      } finally {
        this.loadingEmployee = false
      }
    },
    async onSelectPictureImage() {
      try {
        this.form.picture = await OpenGiftFinder()
      } catch (e) {
        notifyService.error(e)
      }
    },
    onSelectDepart(option) {
      this.selectedDepartNo = option
      this.form.department_no = option || null

      this.loadEmployee()
    },
    onSelectEmployee(option) {
      this.selectedEmployeeCode = option
      this.form.employee_code = option || null
    },
    onSelectConsumable(consumable) {
      if (consumable) {
        this.form.net_price = 0
        this.form.sale_price = 0
        this.form.dividend_point = 0
      }
    },
    async onSend() {
      this.$v.$touch()

      if (this.$v.$invalid) {
        return
      }

      this.$emit('send', this.form)
    }
  }
}
</script>
